import { useTranslation } from "react-i18next";
import CardBase from "../../../components/CardBase";
import { useContext, useEffect, useState } from "react";
import { GlobalContext } from "../../../../../common/Context";
import { Box, Button, Typography } from "@mui/material";
import ReactPlayer from "react-player";
import LoadingWheel from "../../../../../common/LoadingWheel";
import { blue, green, white } from "../../../../../../theme/colours";

const WeeklyVideo = (props) => {
  const { votw } = props;
  const { t } = useTranslation("Dashboard");
  const {
    userState,
    mobileView,
    tabletView,
    desktopView,
    largeView,
    setOptionState,
    optionState,
  } = useContext(GlobalContext);
  const nav = (userState.isTlcViewer || userState.isTlcAdmin) && "levelUp";

  const [playing, setPlaying] = useState(false);

  useEffect(() => {
    if (optionState.nav !== "dashboard") {
      setPlaying(false);
    }
  }, [optionState.nav]);

  const votwBoxStyle = {
    width: largeView ? "40%" : tabletView ? "49%" : mobileView ? "100%" : "31%",
    height: "100%",
    mb: mobileView && "1rem",
  };
  const votwAreaStyle = {
    width: "100%",
    height: "100%",
    padding: "1rem",
    display: "flex",
  };
  const playerWrapper = {
    borderRadius: "0.5rem",
    overflow: "hidden",
    position: "relative",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    width: desktopView ? "35%" : "45%",
  };
  const playerStyle = {
    borderRadius: "5px",
  };
  const votwTextAreaStyle = {
    display: "flex",
    flexDirection: "column",
    pl: desktopView ? "5%" : "4%",
    flex: 1,
    justifyContent: "center",
    width: mobileView ? "calc(100% - 132px)" : "auto",
  };
  const votwTitleStyle = {
    mb: "1rem",
    maxHeight: "2.25rem",
    overflow: "hidden",
    textOverflow: "ellipsis",
    display: "-webkit-box",
    WebkitLineClamp: "2",
    WebkitBoxOrient: "vertical",
  };
  const recoBtnStyle = {
    background: green[1],
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    borderRadius: "5px",
    height: "1.25rem",
    maxWidth: "7rem",
    mb: "1rem",
  };
  const watchNowBtnStyle = {
    mt: "1rem",
    maxWidth: "12rem",
  };
  const boldStyle = {
    fontWeight: 700,
    fontSize: "0.65rem",
  };
  const vidDescTextStyle = {
    height: "4.5rem",
    overflow: "hidden",
    textOverflow: "ellipsis",
    display: "-webkit-box",
    WebkitLineClamp: "6",
    WebkitBoxOrient: "vertical",
  };
  const noTrypsBox = {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    height: "100%",
    width: "100%",
    flexDirection: "column",
    padding: "2rem",
  };
  const errorSubTitleStyle = {
    opacity: "50%",
    mt: "0.5rem",
    textAlign: "center",
    width: "350px",
    lineHeight: "1.5",
  };

  const changeNav = (type) => {
    setOptionState({ nav: type, page: "main" });
  };

  return (
    <CardBase
      title={t("VOTW")}
      redirect={nav}
      headerColor={blue[2]}
      boxStyle={votwBoxStyle}
      areaStyle={votwAreaStyle}>
      {votw ? (
        <>
          <Box sx={playerWrapper}>
            <ReactPlayer
              id={votw.id}
              url={votw.url}
              controls={true}
              width="100%"
              height="230px"
              loop={false}
              sx={playerStyle}
              light
              onPlay={() => setPlaying(true)}
              playing={playing}
            />
          </Box>
          <Box sx={votwTextAreaStyle}>
            <Box sx={recoBtnStyle}>
              <Typography sx={boldStyle} color={white}>
                {t("reco")}
              </Typography>
            </Box>
            <Typography sx={votwTitleStyle} variant="h3">
              {votw.title}
            </Typography>
            <Typography sx={vidDescTextStyle} variant="body2">
              {votw.description}
            </Typography>
            {userState.isAdmin || userState.isViewer ? (
              <Button
                sx={watchNowBtnStyle}
                variant="contained"
                onClick={() => changeNav("levelUp")}>
                {t("watchNow")}
              </Button>
            ) : (
              <></>
            )}
          </Box>
        </>
      ) : votw === false ? (
        <Box sx={noTrypsBox}>
          <Typography variant="h4">{t("noVideosT")}</Typography>
          <Typography sx={errorSubTitleStyle}>{t("noVideosD")}</Typography>
        </Box>
      ) : (
        <LoadingWheel width={3} />
      )}
    </CardBase>
  );
};

export default WeeklyVideo;
